enum ShoppingCartStatus {
  proposed = 'Proposed',
  sent = 'Sent',
  open = 'Open',
  sold = 'Sold'
}

export default ShoppingCartStatus;
